import Image0 from '../../assets/Convergence.png'
import Image1 from '../../assets/resume.jpg'
import Image2 from '../../assets/flashcard.jpg'
import Image3 from '../../assets/youtube.png'
import Image5 from '../../assets/portfolio.png'
import Image6 from '../../assets/kapstan.png'



const data = [
     {
        id: 1,
        category: 'Frontend',
        image: Image0,
        title: "(Convergence) IoT Industrial Monitoring Platform (Frontend)",
        desc : "Built and maintained data-intensive React dashboards for an Industry 4.0 IoT platform used to monitor machine health, downtime, production metrics, and operational efficiency across manufacturing plants.",
        // demo: 'https://borsetushar.github.io/resume-app/',
        // github: 'https://github.com/borsetushar/resume-app.git'
    },
    {
        id: 2,
        category: 'Frontend',
        image: Image1,
        title: "Resume Builder (Frontend)",
        desc : "The Almabetter Resume Builder makes your resume making process easy and simple.",
        demo: 'https://borsetushar.github.io/resume-app/',
        github: 'https://github.com/borsetushar/resume-app.git'
    },

    {
        id: 3,
        category: 'Frontend',
        image: Image2,
        title: "Flashcard Generator (Frontend)",
        desc : "The Flashcard Generator is a web application built using React that allows users to create and manage their own flashcards for studying and learning purposes..",
        demo: 'https://borsetushar.github.io/flashcard-generate-app/',
        github: 'https://github.com/borsetushar/flashcard-generate-app.git'
    },

    {
        id: 4,
        category: 'Backend',
        image: Image3,
        title: "Youtube Subscribers (Backend)",
        desc : "The YouTube Subscribers project is a backend application developed using Node.js and MongoDB. It provides a set of APIs to manage and retrieve subscriber data.",
        // demo: 'https://borsetushar.github.io/flashcard-generate-app/',
        github: 'https://github.com/borsetushar/Youtube-Subscribers.git'
    },

    // {
    //     id: 5,
    //     category: 'FullStack',
    //     image: Image4,
    //     title: "Reserve Bus (FullStack)",
    //     desc : "The Reserve Bus app project is a FullStack  application developed using MongoDB, Express.JS, React.Js, and Node.js. It enable user to a book a seat Online.",
    //     demo: 'https://borsetushar.github.io/reserve-app/',
    //     github: 'https://github.com/borsetushar/reserve-app.git'
    // },

    {
        id: 5,
        category: 'Frontend',
        image: Image5,
        title: "Portfolio (Frontend)",
        desc : "The Portfolio app is a react web application developed using Html, CSS, Javascript and React js.The purpose of this web app is to showcase my Skills along with the projects i have worked on.",
        demo: 'https://borsetushar.github.io/rportfolio/',
        github: 'https://github.com/borsetushar/rportfolio.git'
    },

    {
        id: 6,
        category: 'Frontend',
        image: Image6,
        title: "Kapstan (Frontend)",
        desc : "The Kapstan app is a  web app that is use to manage the application deployment and health monitoring on cloud.",
        demo: 'https://borsetushar.github.io/kapstan/',
        github: 'https://github.com/borsetushar/kapstan'
    },
]

export default data;